import React, { FC, useState } from 'react';
import Router from 'next/router';
import { logEvent } from '@/analytics';
import { useGetTradeBalance } from '@/queries/trade';
import { HamiSlideBackgroundGradient } from './constants';
import { useMelliCardIssueStatus } from '@/modules/fundTransfer/hooks';
import HamiBalanceSlideAmount from './components/HamiBalanceSlideAmount';
import HamiBalanceSlideCard from './components/HamiBalanceSlideCard';
import HamiBalanceSlideCardNew from './components/HamiBalanceSlideCardNew';
import HamiBalanceSlideCurrency from './components/HamiBalanceSlideCurrency';
import HamiBalanceSlideTitle from './components/HamiBalanceSlideTitle';
import {
  HamiBalanceSlideCardBack,
  HamiBalanceSlideCardWrapper,
} from './components';
import { useUnleash } from '@/unleash';
import { useIsMasked } from '@/hooks/isMasked';
import { IBalanceCardProps } from '../BalanceSlide.types';

export interface IHamiBalanceSlideProps extends Partial<IBalanceCardProps> {}

const HamiBalanceSlide: FC<IHamiBalanceSlideProps> = (props) => {
  const { isMasked, setIsMasked } = useIsMasked();
  const [showBalance, setShowBalance] = useState(false);

  const { data, isLoading, isError, refetch, isFetching } = useGetTradeBalance({
    refetchOnWindowFocus: false,
    enabled: false, // disable this query from automatically running
  });

  const balance = data?.balance!;
  const isLoadingOrFetching = isNaN(balance) ? isFetching : isLoading;
  const commonProps = !isMasked
    ? { isLoading: isLoadingOrFetching, isError: isError }
    : {};
  const { enabled: isMelliCardCardEnabled } = useUnleash('web.melliCard.card');

  const {
    isAccountAlreadyCreated: isMelliCardAccountAlreadyCreated,
    melliCardInquiry,
  } = useMelliCardIssueStatus({ isGetCreateAccountStatusEnabled: false });

  const sharedProps = {
    amount: (
      <HamiBalanceSlideAmount
        {...commonProps}
        amount={balance}
        onRefetch={refetch}
      />
    ),
    buttonAction: () => {
      logEvent('ACCOUNT_HISTORY_CLICK');
      Router.push('/transactions');
    },
    buttonProps: { id: 'home_click_accountTransactions' },
    buttonTitle: 'گردش حساب',
    currency: <HamiBalanceSlideCurrency {...commonProps} />,
    isMasked: showBalance ? isMasked : true,
    title: <HamiBalanceSlideTitle {...commonProps} />,
    onMaskChange: (isMasked: boolean) => setIsMasked(isMasked),
    ...props,
    isError,
    isFetching,
    refetch,
    setShowBalance,
    showBalance,
  };

  if (isMelliCardCardEnabled)
    return <HamiBalanceSlideCardNew {...sharedProps} />;

  return (
    <HamiBalanceSlideCardWrapper
      dragSensitivity={-10}
      isMelliCardAccountAlreadyCreated={isMelliCardAccountAlreadyCreated}
    >
      <HamiBalanceSlideCard
        className={HamiSlideBackgroundGradient}
        {...sharedProps}
      />
      {isMelliCardAccountAlreadyCreated && (
        <HamiBalanceSlideCardBack
          className={HamiSlideBackgroundGradient}
          melliCardInquiry={melliCardInquiry}
        />
      )}
    </HamiBalanceSlideCardWrapper>
  );
};

export default HamiBalanceSlide;
